import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  AppBar,
  Toolbar,
  Avatar,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import logo from "../img/logofot.png";

export default function Dashboard() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
        color: "white",
      }}
    >
      {/* HEADER */}
      <AppBar
        position="static"
        sx={{ background: "transparent", boxShadow: "none" }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          {/* LOGO + NOMBRE EMPRESA */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Avatar
              src={logo} // 🔥 coloca aquí tu logo
              sx={{ width: 45, height: 45, boxShadow: 3 }}
            />
            <Typography variant="h6" fontWeight="bold">
              Repositorio de empresas afiliación
            </Typography>
          </Box>

          <Typography variant="caption" sx={{ opacity: 0.8 }}>
            Bienvenido al panel administrativo
          </Typography>
        </Toolbar>
      </AppBar>

      {/* CONTENIDO */}
      <Box sx={{ p: 5 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Bienvenido
        </Typography>

        <Typography variant="subtitle1" sx={{ opacity: 0.8, mb: 4 }}>
          Selecciona una opción para continuar
        </Typography>

        <Grid container spacing={4}>
          {/* CONSULTAR */}
          <Grid item xs={12} md={4}>
            <Card
              onClick={() => navigate("/buscar")}
              sx={{
                p: 2,
                cursor: "pointer",
                borderRadius: 4,
                background: "rgba(255,255,255,0.08)",
                backdropFilter: "blur(10px)",
                color: "white",
                transition: "0.3s",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.4)",
                },
              }}
            >
              <CardContent>
                <SearchIcon sx={{ fontSize: 40, mb: 1 }} />
                <Typography variant="h6">Consultar Afiliado</Typography>
                <Typography sx={{ opacity: 0.8 }}>
                  Consultar registro de empresa
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* CREAR */}
          <Grid item xs={12} md={4}>
            <Card
              onClick={() => navigate("/crear")}
              sx={{
                p: 2,
                cursor: "pointer",
                borderRadius: 4,
                background: "rgba(255,255,255,0.08)",
                backdropFilter: "blur(10px)",
                color: "white",
                transition: "0.3s",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.4)",
                },
              }}
            >
              <CardContent>
                <PersonAddIcon sx={{ fontSize: 40, mb: 1 }} />
                <Typography variant="h6">Crear Afiliado</Typography>
                <Typography sx={{ opacity: 0.8 }}>
                  Registrar un nuevo afiliado en el sistema
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* VALOR */}
          <Grid item xs={12} md={4}>
            <Card
              onClick={() => navigate("/valor")}
              sx={{
                p: 2,
                cursor: "pointer",
                borderRadius: 4,
                background: "rgba(255,255,255,0.08)",
                backdropFilter: "blur(10px)",
                color: "white",
                transition: "0.3s",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.4)",
                },
              }}
            >
              <CardContent>
                <AttachMoneyIcon sx={{ fontSize: 40, mb: 1 }} />
                <Typography variant="h6">Consultar Valor</Typography>
                <Typography sx={{ opacity: 0.8 }}>
                  Consultar valor de afiliación desde la búsqueda
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
